import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = { class: "card-notificacao" }
const _hoisted_3 = { class: "mensagem" }
const _hoisted_4 = { class: "btn-wrapper" }

import { useNotificacaoStore } from "@/shared/store/notificacao_store";


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificacaoComponent',
  setup(__props) {

const store = useNotificacaoStore();

return (_ctx: any,_cache: any) => {
  return (_unref(store).isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", {
            class: _normalizeClass(["titulo", { erro: !_unref(store).isSuccess }])
          }, _toDisplayString(_unref(store).titulo), 3),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(store).mensagem), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "btn-fechar",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(store).close && _unref(store).close(...args)))
            }, "Fechar")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})